import Vue from "vue";
import vueSmoothScroll from "vue-smoothscroll";

Vue.use(vueSmoothScroll);

new Vue({
  el: "#app",
  data: {
    menu_active: false,
    header_active: false,
  },
  computed: {},
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    clickSmoothScroll(target) {
      this.$SmoothScroll(
        document.querySelector("#" + target),
        600,
        null,
        null,
        "y"
      );
    },
    clickScrollTop() {
      this.$SmoothScroll(0, 600, null, null, "y");
    },
    handleScroll() {
      const scrollY = window.scrollY;
      const windowHieght = window.innerHeight;
      const scrollBottom = scrollY + windowHieght;

      const target_top = $("body").offset().top;
      const target_height = $("body").innerHeight();

      if (scrollY > 100) {
        this.header_active = true;
      } else {
        this.header_active = false;
      }
    },
  },
});

/* eslint-disable no-undef */
$(function () {
  $(".inview").on("inview", function (e, isInView) {
    if (isInView) {
      $(this).addClass("is-inview");
    }
  });

  $(".slideToggleBtn").on("click", function () {
    $(this).parents(".slideToggle").toggleClass("is-open");
  });
  $(".form .error").parents(".form__group").addClass("is-error");

  /* フォーカスでエラー解除 */
  $(".is-error input").on("focus", function () {
    $(this).parents(".form__group").removeClass("is-error");
    $(this).parents(".form__group").find(".error").css({ display: "none" });
  });
  $(".is-error textarea").on("focus", function () {
    $(this).parents(".form__group").removeClass("is-error");
    $(this).parents(".form__group").find(".error").css({ display: "none" });
  });
  $(".is-error select").on("focus", function () {
    $(this).parents(".form__group").removeClass("is-error");
    $(this).parents(".form__group").find(".error").css({ display: "none" });
  });

  $(".input__file").on("change", function () {
    var file = $(this).prop("files")[0];
    $(this).parents(".form__group").find(".form__fileName").text(file.name);
    //$('p').text(file.name);
  });
});
